import React from 'react';

// Reusable slide-up bottom sheet for the phone UI. Tapping the backdrop or the
// × closes it; the body scrolls if its content overflows.
export default function BottomSheet({ open, title, onClose, children, height }) {
  if (!open) return null;
  return (
    <div className="m-sheet-backdrop" onClick={onClose}>
      <div
        className="m-sheet"
        style={height ? { maxHeight: height } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="m-sheet-grabber" />
        <div className="m-sheet-header">
          <span className="m-sheet-title">{title}</span>
          <button className="m-sheet-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="m-sheet-body">{children}</div>
      </div>
    </div>
  );
}
